export const editorConfig = {
  height: 540,
  width: 540,
};
